import {combineReducers} from 'redux'
import {payload, payloadStatus } from './reports'
import {
	currentDates,
	compareDates,
	overlayStatus,
	loadingStatus,
	loadingStatusMessage,
	compareStatus,
	trafficSources,
	activeProperties,
	viewAs,
	tableExporting,
} from "./general"
import {homes} from './homes'
import { navigatorOverlayStatus, navigatorStatus, navigator } from './navigator'
import { trafficRows } from './entry'

export default combineReducers({
	currentDates,
	compareDates,
	overlayStatus,
	loadingStatus,
	loadingStatusMessage,
	compareStatus,
	trafficSources,
	trafficRows,
	homes,
	payload,
	activeProperties,
	viewAs,
	payloadStatus,
	navigatorOverlayStatus,
	navigatorStatus,
	navigator,
	tableExporting,
})
